import React from 'react'
import styles from "./style.module.scss"

const Home: React.FC = () => {
   return (
      <div className={`${styles.main} d-flex`}>
         <div className={`${styles.start} card d-flex`}>
            <h1>welcome!!!</h1>
            <div className="btnbox">
               <a href="/start">let's play</a>
               <a href="/about">about</a>
            </div>
         </div>
      </div>
   )
}

export default Home